// 组件对象，大写
import uploadNormal from './uploadNormal.vue'
export default uploadNormal
